import { lazy, Suspense } from 'react'
import { createBrowserRouter, ScrollRestoration } from 'react-router-dom'

import './App.css'
// import '@fontsource/roboto/300.css'
// import '@fontsource/roboto/400.css'
// import '@fontsource/roboto/500.css'
// import '@fontsource/roboto/700.css'

// import './GlobalStyles.scss'

// ROUTES
const MainRoute = lazy(()=>import('./Components/Routes/MainRoute'))
const SigningRoute = lazy(()=>import('./Components/Routes/SigningRoute'))
const LoggedOutRoutes = lazy(()=>import('./Components/Routes/LoggedOutRoutes'))
const ErrorRoute = lazy(()=>import('./Components/Routes/ErrorRoute'))

const Router = createBrowserRouter([
	{
		path: '/',
		errorElement: <Suspense fallback=''><ErrorRoute /></Suspense>,
		children: [
			// Logged out
			{ path: '/', element: ( <><ScrollRestoration /><Suspense fallback=''><LoggedOutRoutes route={''} /></Suspense></> ), },
			{ path: '/about', element: ( <><ScrollRestoration /><Suspense fallback=''><LoggedOutRoutes route={'about'} /></Suspense></> ), },

			// Terms
			{ path: '/terms', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'terms'} /></Suspense></> ), },
			{ path: '/contact', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'contact'} /></Suspense></> ), },


			// Signing up/in
			{ path: '/signup', element: ( <><ScrollRestoration /><Suspense fallback=''><SigningRoute route={'signup'} /></Suspense></> ), },
			{ path: '/signin', element: ( <><ScrollRestoration /><Suspense fallback=''><SigningRoute route={'signin'} /></Suspense></> ), },
			{ path: '/resetPassword', element: ( <><ScrollRestoration /><Suspense fallback=''><SigningRoute route={'resetPassword'} /></Suspense></> ), },


			// Signed in routes
			{ path: '/onboarding', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'onboarding'} /></Suspense></> ), },
			// { path: '/profileSettings', element: ( <><ScrollRestoration /><MainRoute route={'profileSettings'} /></> ), },

			{ path: '/home', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'home'} /></Suspense></> ), },
			{ path: '/noticeboard', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'noticeboard'} /></Suspense></> ), },
			{ path: '/resources', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'resources'} /></Suspense></> ), },
			{ path: '/members', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'members'} /></Suspense></> ), },
			// { path: '/charter', element: ( <><ScrollRestoration /><MainRoute route={'charter'} /></> ), },
			{ path: '/support', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'support'} /></Suspense></> ), },
			// { path: '/tutorials', element: ( <><ScrollRestoration /><MainRoute route={'tutorials'} /></> ), },

			{ path: '/post/:id', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'post'} /></Suspense></> ), },
			{ path: '/createPost/:id', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'createPost'} /></Suspense></> ), },

			{ path: '/profile/:uid', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'profile'} /></Suspense></> ), },
			{ path: '/notifications', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'notifications'} /></Suspense></> ), },
			{ path: '/message/:id', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'message'} /></Suspense></> ), },
			{ path: '/messages', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'messages'} /></Suspense></> ), },

			{ path: '/admin', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'admin'} /></Suspense></> ), },


			// Series
			{ path: '/seriesEditor/:id', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'seriesEditor'} /></Suspense></> ), },
			{ path: '/course/:courseId', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'course'} /></Suspense></> ), },
			{ path: '/course/:courseId/page/:pageNumber', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'coursePage'} /></Suspense></> ), },




			{ path: '/updates', element: ( <><ScrollRestoration /><Suspense fallback=''><MainRoute route={'updates'} /></Suspense></> ), },


		],
	}
])

export default Router